import { LicenseInfo } from '@mui/x-license-pro';

const applyLicense = () => LicenseInfo.setLicenseKey('32d0dd902dc4550732d2c3df2a7fdce7T1JERVI6MjM4OTMsRVhQSVJZPTE2NTA0NDYxNDMwMDAsS0VZVkVSU0lPTj0x');

export default applyLicense;